export default __webpack_public_path__ + "images/31_1_image.jpg";